export default __webpack_public_path__ + "static/media/vo_es.05ffb86c.m4a";